import { GridColDef } from "@mui/x-data-grid";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { TbRocket } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { WeTrackVehicleData } from "@/types/wetrack.types";

export const LastIgnitionDate = (): GridColDef<WeTrackVehicleData["properties"]> => {
    return {
        field: "last_ignition",
        headerName: "lastOpenIgnition",
        minWidth: 160,
        type: "number",
        renderHeader: (params) => (
            <TableHeader description="lastOpenIgnitionDesc" Component={TbRocket} title={params.colDef.headerName!} />
        ),
        renderCell: (params) => {
            const { i18n } = useTranslation();
            return (
                <div className="flex p-1 items-center font-medium h-full gap-1  text-xs">
                    {DateTime.fromSeconds(params.row.last_ignition)
                        .setLocale(i18n.language)
                        .toFormat("dd MMMM yyyy, HH:mm")}
                </div>
            );
        },
    };
};
